/** Valor del multiselect de categorías para productos sin categoría primaria. */
export const UNCATEGORIZED_CATEGORY_FILTER_ID = '__uncategorized__';

export interface ProductListFilters {
  /** `undefined`: comportamiento por defecto del listado (solo activos). `true`/`false`: filtrar. `null`: sin filtro (todos). */
  activeOnly?: boolean | null;
  /**
   * Ids de canal (p. ej. `pos`). Vacío/null: sin filtro por visibilidad en GraphQL.
   * Con valores: `visibleInChannels` en servidor (AND entre canales).
   */
  visibleInChannels?: string[] | null;
  /** @deprecated Usar {@link visibleInChannels}. */
  visibilityFilters?: string[] | null;
  /** `simple` | `variable`; omitido/null: sin filtro (servidor). */
  productStructure?: 'simple' | 'variable' | null;
  /**
   * Categorías asignadas (OR: coincide si el producto tiene alguna), más {@link UNCATEGORIZED_CATEGORY_FILTER_ID} para sin categoría.
   * Vacío = sin filtro. Se envían como `categoryIds` + `includeUncategorized` en GraphQL.
   */
  categoryIds?: string[] | null;
  /** Búsqueda parcial por nombre (LIKE). Vacío/null: sin filtro en servidor. */
  name?: string | null;
  /** Solo productos con variantes que usan este valor de atributo. */
  attributeValueId?: string | null;
  /** Solo productos que usan esta definición de atributo (asignación o variaciones). */
  attributeDefinitionId?: string | null;
  /** Solo productos que usan esta definición de grupo de modificadores. */
  modifierGroupDefinitionId?: string | null;
  /** Solo productos que usan esta definición de opción de modificador. */
  modifierOptionDefinitionId?: string | null;
}
